import { Component, Input } from '@angular/core';
import { CarouselInterface } from '@app/core/interfaces';

@Component({
    selector: 'ins-image-carousel',
    templateUrl: 'image-carousel.component.html',
    styleUrls: ['image-carousel.component.scss']
})
export class ImageCarouselComponent {
    @Input() items: CarouselInterface[];

    constructor() {
    }
}
